import { render, staticRenderFns } from "./Buscar.vue?vue&type=template&id=4d3c8638&"
import script from "./Buscar.vue?vue&type=script&lang=js&"
export * from "./Buscar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports